import { cn } from "@/common/helpers/utils";
import { config } from "@/config/configuration";
import { generateCompositionUrl, WebPlayer } from "@car-cutter/react-webplayer";
import { useState } from "react";
import "./car-cutter-theme.css";
import { CarCutterWebPlayerFallback } from "./car-cutter-web-player-fallback";
import { CarCutterWebPlayerLoading } from "./car-cutter-web-player-skeleton";

const enum MediaStatus {
  Loading,
  Ready,
  Error,
}

interface CarCutterWebPlayerProps {
  vin: string;
  className?: string;
}

export const CarCutterWebPlayer = ({ vin, className }: CarCutterWebPlayerProps) => {
  const customerToken = config.carCutterCustomerToken;
  const hasMedia = Boolean(vin && customerToken);

  const [status, setStatus] = useState<MediaStatus>(MediaStatus.Loading);

  if (!hasMedia || status === MediaStatus.Error) {
    return (
      <div className={cn("car-cutter-themed", className)}>
        <CarCutterWebPlayerFallback />
      </div>
    );
  }

  return (
    <div className={cn("car-cutter-themed", className)}>
      {status === MediaStatus.Loading && <CarCutterWebPlayerLoading />}
      <div className={cn(status !== MediaStatus.Ready && "hidden")}>
        <WebPlayer
          style={{ borderRadius: "16px", overflow: "hidden" }}
          compositionUrl={generateCompositionUrl(customerToken, vin)}
          onCompositionLoaded={() => setStatus(MediaStatus.Ready)}
          onCompositionLoadError={() => setStatus(MediaStatus.Error)}
          spinCursor="grab"
          infiniteCarrousel
          autoLoad360
          demoSpin={false}
        />
      </div>
    </div>
  );
};
